export const perspectives = ['objective', 'subjective'];
export const variableType_Normal = 'normal';
export const variableType_Attribute = 'attribute';
export const variableType_AttributeInstance = 'attribute-instance';
export const variableType_RelievingFactor = 'relieving-factor';
export const variableType_PrecipitatingFactor = 'precipitating-factor';
export const variableType_HistoryOf = 'history-of';
export const variableType_FamilyHistoryOf = 'family-history-of';
export const variableType_EvidenceOf = 'evidence-of';
export const variableType_Recent = 'recent';
export const VariableTypes = [
    variableType_Normal,
    variableType_Attribute,
    variableType_AttributeInstance,
    variableType_RelievingFactor,
    variableType_PrecipitatingFactor,
    variableType_HistoryOf,
    variableType_FamilyHistoryOf,
    variableType_EvidenceOf,
    variableType_Recent,
];
//# sourceMappingURL=types.js.map